'use strict'
import MSALInstance, { BasicAuth } from '../auth/auth'

export const handleUnauthRoute = (to, from, next) => {
  const msalAuth = MSALInstance.checkAuth()
  const basicAuth = BasicAuth.checkAuth()
  Promise.any([msalAuth, basicAuth])
    .then(() => next('/'))
    .catch(() => next())
}

export const handleAuthRoute = (to, from, next) => {
  const msalAuth = MSALInstance.checkAuth()
  const basicAuth = BasicAuth.checkAuth()
  Promise.any([msalAuth, basicAuth])
    .then(() => next())
    .catch(() => next({ path: '/login' }))
}
